import { BASE_PATH } from './index';

const APILink = {
  AUTH_VERIFY: `${BASE_PATH}/auth/debug`,
  FIREBASE_TOKEN: `${BASE_PATH}/firebase/token`,
};

export default APILink;
